import React from 'react';
import {
  AppBar,
  Box,
  createTheme,
  IconButton,
  Stack,
  ThemeProvider,
  Toolbar,
  Typography,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { USER_NAME } from '../../constant/constants';
import { MAIN_ROUTE, SIGN_IN_ROUTE } from '../../constant/routes';

export const MainNavigationBar = () => {
  const navigate = useNavigate();

  const darkTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#212121',
      },
    },
  });

  const logout = () => {
    localStorage.clear();
    navigate(SIGN_IN_ROUTE);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <ThemeProvider theme={darkTheme}>
        <AppBar position="static">
          <Toolbar>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Stack
                direction="row"
                alignItems="center"
                onClick={() => navigate(MAIN_ROUTE)}
                spacing={2}
              >
                <Typography
                  style={{
                    fontFamily: 'sans-serif',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '18px',
                    color: '#FFFFFF',
                  }}
                  component="text"
                >
                  Учи Мед 2D Конспекты
                </Typography>
              </Stack>
            </Stack>
            <div style={{ flex: 1 }}> </div>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '18px',
                color: '#FFFFFF',
              }}
              component="text"
            >
              Автор {localStorage.getItem(USER_NAME)}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={2}>
              <IconButton
                size="large"
                onClick={logout}
                sx={{ color: '#ffFFff' }}
              >
                <LogoutIcon />
              </IconButton>
            </Stack>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </Box>
  );
};
